var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFourDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C12.1046 6 13 5.10457 13 4C13 2.89543 12.1046 2 11 2C9.89542 2 9 2.89543 9 4C9 5.10457 9.89542 6 11 6Z",
    fill: "#A3A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 6C5.10458 6 6 5.10457 6 4C6 2.89543 5.10458 2 4.00001 2C2.89544 2 2 2.89543 2 4C2 5.10457 2.89544 6 4.00001 6Z",
    fill: "#A3A1AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89542 9 9 9.89543 9 11C9 12.1046 9.89542 13 11 13Z",
    fill: "#A3A1AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 13C5.10458 13 6 12.1046 6 11C6 9.89543 5.10458 9 4.00001 9C2.89544 9 2 9.89543 2 11C2 12.1046 2.89544 13 4.00001 13Z",
    fill: "#A3A1AA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourDotMenu);
export default __webpack_public_path__ + "static/media/fourDotMenu.8c13c276.svg";
export { ForwardRef as ReactComponent };